(() => {
  const initializeAntixExperience = (root) => {
    if (!root || root.dataset.antixInitialized === 'true') return;

    root.dataset.antixInitialized = 'true';
    document.body.classList.add('antix-full-experience-active');

    const modeButtons = root.querySelectorAll('[data-antix-mode-button]');
    const views = root.querySelectorAll('[data-antix-view]');
    const roamView = root.querySelector('[data-antix-view="roam"]');
    const roamCards = root.querySelectorAll('.antix-experience__roam-card');
    const productView = root.querySelector('[data-antix-product-view]');
const productPanels = root.querySelectorAll('[data-antix-product-panel]');
const productClose = root.querySelector('[data-antix-product-close]');
const gridProductLinks = root.querySelectorAll(
  '.antix-experience__grid-card .antix-experience__product-link'
);

const menu = root.querySelector('[data-antix-menu]');
const menuButton = root.querySelector('[data-antix-menu-button]');
const menuClose = root.querySelector('[data-antix-menu-close]');
const menuLinks = root.querySelectorAll('[data-antix-menu-link]');

const themeButton = root.querySelector('[data-antix-theme-button]');

const applyTheme = (theme) => {
  const isLight = theme === 'light';

  root.classList.toggle('is-light-theme', isLight);

  if (themeButton) {
    themeButton.setAttribute('aria-pressed', String(isLight));
    themeButton.setAttribute(
      'aria-label',
      isLight ? 'Switch to dark mode' : 'Switch to light mode'
    );
  }
};

let currentTheme = 'dark';

try {
  currentTheme =
    localStorage.getItem('antix-theme') === 'light'
      ? 'light'
      : 'dark';
} catch (error) {
  currentTheme = 'dark';
}

applyTheme(currentTheme);

const artboard = root.querySelector(
  '[data-antix-artboard]'
);

const artboardClose = root.querySelector(
  '[data-antix-artboard-close]'
);

const information = root.querySelector(
  '[data-antix-information]'
);

const informationClose = root.querySelector(
  '[data-antix-information-close]'
);

const productForms = root.querySelectorAll(
  '.antix-experience__product-form'
);

const cartCount = root.querySelector('[data-antix-cart-count]');

const cartButton = root.querySelector(
  '.antix-experience__cart-button'
);

const cartLayer = root.querySelector(
  '[data-antix-cart-layer]'
);

const cartCloseButtons = root.querySelectorAll(
  '[data-antix-cart-close]'
);

const cartItems = root.querySelector(
  '[data-antix-cart-items]'
);

const cartEmpty = root.querySelector(
  '[data-antix-cart-empty]'
);

const cartFooter = root.querySelector(
  '[data-antix-cart-footer]'
);

const cartSubtotal = root.querySelector(
  '[data-antix-cart-subtotal]'
);

const cartTitleCount = root.querySelector(
  '[data-antix-cart-title-count]'
);

const shopRoot =
  window.Shopify && window.Shopify.routes
    ? window.Shopify.routes.root
    : '/';

    let dragging = false;
    let moved = false;
    let startX = 0;
    let startY = 0;
    let currentX = 0;
    let currentY = 0;
    let savedX = 0;
    let savedY = 0;
    let activeProductHandle = '';
let currentMode = 'roam';

    const updateRoamPosition = () => {
      roamCards.forEach((card) => {
        card.style.translate = `${currentX}px ${currentY}px`;
      });
    };

    const roamSlotClasses = [
  'is-roam-slot-1',
  'is-roam-slot-2',
  'is-roam-slot-3',
  'is-roam-slot-4',
  'is-roam-slot-5'
];

const setRoamFocus = (focusedCard) => {
  const cards = Array.from(roamCards);
  const focusedIndex = cards.indexOf(focusedCard);

  if (focusedIndex === -1) return;

  cards.forEach((card, index) => {
    roamSlotClasses.forEach((slotClass) => {
      card.classList.remove(slotClass);
    });

    const relativeIndex =
      (index - focusedIndex + cards.length) % cards.length;

    const slotIndex = Math.min(
      relativeIndex,
      roamSlotClasses.length - 1
    );

    card.classList.add(roamSlotClasses[slotIndex]);
  });
};

if (roamCards.length > 0) {
  setRoamFocus(roamCards[0]);
}
    const openProduct = (handle) => {
  if (!handle || !productView) return;

  const activePanel = Array.from(productPanels).find(
    (panel) => panel.dataset.antixProductPanel === handle
  );

  if (!activePanel) return;

  if (typeof activePanel.resetAntixGallery === 'function') {
  activePanel.resetAntixGallery();
}

  productPanels.forEach((panel) => {
    const isActive = panel === activePanel;

    panel.hidden = !isActive;
    panel.classList.toggle('is-active', isActive);
  });

  productView.hidden = false;
  productView.classList.add('is-active');
  root.classList.add('is-product-open');
};

const closeProduct = () => {
  if (!productView) return;

  productView.classList.remove('is-active');
  productView.hidden = true;
  root.classList.remove('is-product-open');

  productPanels.forEach((panel) => {
    panel.hidden = true;
    panel.classList.remove('is-active');
  });

  activeProductHandle = '';
};

const openMenu = () => {
  if (!menu) return;

  menu.hidden = false;
  menu.classList.add('is-active');
  root.classList.add('is-menu-open');
  document.body.classList.add('antix-menu-open');

  if (menuButton) {
    menuButton.setAttribute('aria-expanded', 'true');
  }
};

const closeMenu = () => {
  if (!menu) return;

  menu.classList.remove('is-active');
  menu.hidden = true;
  root.classList.remove('is-menu-open');
  document.body.classList.remove('antix-menu-open');

  if (menuButton) {
    menuButton.setAttribute('aria-expanded', 'false');
  }
};

const openArtboard = () => {
  if (!artboard) return;

  closeMenu();
  closeInformation();
  closeProduct();

  artboard.hidden = false;
  artboard.classList.add('is-active');
  root.classList.add('is-artboard-open');
  document.body.classList.add('antix-artboard-open');

  artboard.scrollTop = 0;
};

const closeArtboard = () => {
  if (!artboard) return;

  artboard.classList.remove('is-active');
  artboard.hidden = true;
  root.classList.remove('is-artboard-open');
  document.body.classList.remove('antix-artboard-open');
};

const openInformation = () => {
  if (!information) return;

  closeMenu();
  closeProduct();
  closeArtboard();

  information.hidden = false;
  information.classList.add('is-active');
  root.classList.add('is-information-open');
  document.body.classList.add('antix-information-open');

  information.scrollTop = 0;
};

const closeInformation = () => {
  if (!information) return;

  information.classList.remove('is-active');
  information.hidden = true;
  root.classList.remove('is-information-open');
  document.body.classList.remove('antix-information-open');
};

const initializeGallery = (panel) => {
  const images = Array.from(
    panel.querySelectorAll('[data-antix-gallery-image]')
  );

  const dots = Array.from(
    panel.querySelectorAll('[data-antix-gallery-dot]')
  );

  const previousButton = panel.querySelector(
    '[data-antix-gallery-previous]'
  );

  const nextButton = panel.querySelector(
    '[data-antix-gallery-next]'
  );

  if (!images.length) return;

  let currentIndex = 0;

  const showImage = (index) => {
    currentIndex =
      (index + images.length) % images.length;

    images.forEach((image, imageIndex) => {
      const isActive = imageIndex === currentIndex;

      image.hidden = !isActive;
      image.classList.toggle('is-active', isActive);
    });

    dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === currentIndex;

      dot.classList.toggle('is-active', isActive);
      dot.setAttribute(
        'aria-current',
        isActive ? 'true' : 'false'
      );
    });
  };

  if (images.length <= 1) {
    if (previousButton) previousButton.hidden = true;
    if (nextButton) nextButton.hidden = true;

    dots.forEach((dot) => {
      dot.hidden = true;
    });
  }

  if (previousButton) {
    previousButton.addEventListener('click', () => {
      showImage(currentIndex - 1);
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', () => {
      showImage(currentIndex + 1);
    });
  }

  dots.forEach((dot, dotIndex) => {
    dot.addEventListener('click', () => {
      showImage(dotIndex);
    });
  });

  panel.resetAntixGallery = () => {
    showImage(0);
  };

  showImage(0);
};

productPanels.forEach(initializeGallery);

const fetchCart = async () => {
  const response = await fetch(
    `${shopRoot}cart.js`,
    {
      headers: {
        Accept: 'application/json'
      }
    }
  );

  if (!response.ok) {
    throw new Error('Unable to read the cart.');
  }

  return response.json();
};

const formatMoney = (cents, currency = 'USD') => {
  return new Intl.NumberFormat(
    document.documentElement.lang || 'en-US',
    {
      style: 'currency',
      currency
    }
  ).format(cents / 100);
};

const escapeHtml = (value = '') => {
  return String(value).replace(
    /[&<>"']/g,
    (character) => {
      const characters = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      };

      return characters[character];
    }
  );
};

const renderCart = (cart) => {
  const currency =
    cart.currency ||
    (
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active
    ) ||
    'USD';

  if (cartCount) {
    cartCount.textContent = cart.item_count;
    cartCount.hidden = cart.item_count === 0;
  }

  if (cartTitleCount) {
    cartTitleCount.textContent = `(${cart.item_count})`;
  }

  if (cartSubtotal) {
    cartSubtotal.textContent = formatMoney(
      cart.total_price,
      currency
    );
  }

  if (cartEmpty) {
    cartEmpty.hidden = cart.item_count > 0;
  }

  if (cartFooter) {
    cartFooter.hidden = cart.item_count === 0;
  }

  if (!cartItems) return;

  cartItems.innerHTML = '';

  cart.items.forEach((item, index) => {
    const cartItem = document.createElement('article');

    cartItem.className = 'antix-experience__cart-item';

    const imageUrl =
      item.featured_image && item.featured_image.url
        ? item.featured_image.url
        : item.image;

    const variantTitle =
      item.variant_title &&
      item.variant_title !== 'Default Title'
        ? item.variant_title
        : '';

    const linePrice =
      typeof item.final_line_price === 'number'
        ? item.final_line_price
        : item.line_price;

    cartItem.innerHTML = `
      ${
        imageUrl
          ? `
            <img
              class="antix-experience__cart-item-image"
              src="${escapeHtml(imageUrl)}"
              alt="${escapeHtml(item.product_title || item.title)}"
              loading="lazy"
            >
          `
          : `
            <div class="antix-experience__cart-item-image"></div>
          `
      }

      <div class="antix-experience__cart-item-details">
        <h3 class="antix-experience__cart-item-title">
          ${escapeHtml(item.product_title || item.title)}
        </h3>

        ${
          variantTitle
            ? `
              <p class="antix-experience__cart-item-variant">
                ${escapeHtml(variantTitle)}
              </p>
            `
            : ''
        }

        <p class="antix-experience__cart-item-price">
          ${formatMoney(linePrice, currency)}
        </p>

        <div class="antix-experience__cart-item-actions">
          <div class="antix-experience__cart-quantity">
            <button
              type="button"
              aria-label="Decrease quantity"
              data-antix-cart-change
              data-line="${index + 1}"
              data-quantity="${Math.max(item.quantity - 1, 0)}"
            >
              −
            </button>

            <span>${item.quantity}</span>

            <button
              type="button"
              aria-label="Increase quantity"
              data-antix-cart-change
              data-line="${index + 1}"
              data-quantity="${item.quantity + 1}"
            >
              +
            </button>
          </div>

          <button
            type="button"
            class="antix-experience__cart-remove"
            data-antix-cart-change
            data-line="${index + 1}"
            data-quantity="0"
          >
            REMOVE
          </button>
        </div>
      </div>
    `;

    cartItems.appendChild(cartItem);
  });
};

const updateCartCount = async () => {
  const cart = await fetchCart();

  if (cartCount) {
    cartCount.textContent = cart.item_count;
    cartCount.hidden = cart.item_count === 0;
  }

  return cart;
};

const openCart = async () => {
  if (!cartLayer) return;

  const cart = await fetchCart();

  renderCart(cart);

  cartLayer.hidden = false;
  root.classList.add('is-cart-open');
  document.body.classList.add('antix-cart-open');

  window.requestAnimationFrame(() => {
    cartLayer.classList.add('is-active');
  });
};

const closeCart = () => {
  if (!cartLayer) return;

  cartLayer.classList.remove('is-active');
  root.classList.remove('is-cart-open');
  document.body.classList.remove('antix-cart-open');

  window.setTimeout(() => {
    if (!cartLayer.classList.contains('is-active')) {
      cartLayer.hidden = true;
    }
  }, 320);
};

const changeCartLine = async (line, quantity) => {
  const response = await fetch(
    `${shopRoot}cart/change.js`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        line,
        quantity
      })
    }
  );

  const cart = await response.json();

  if (!response.ok) {
    throw new Error(
      cart.description || 'Unable to update the cart.'
    );
  }

  renderCart(cart);

  return cart;
};

productForms.forEach((form) => {
  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    const addButton = form.querySelector(
      '.antix-experience__add-button'
    );

    if (!addButton || addButton.disabled) return;

    const originalButtonHtml = addButton.innerHTML;

    addButton.disabled = true;
    addButton.textContent = 'ADDING...';

    try {
      const response = await fetch(
        `${shopRoot}cart/add.js`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json'
          },
          body: new FormData(form)
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description || 'Unable to add this item.'
        );
      }

      try {
  await updateCartCount();
  await openCart();
} catch (cartError) {
  console.error(cartError);
}

addButton.textContent = 'ADDED TO CART';

      window.setTimeout(() => {
        addButton.innerHTML = originalButtonHtml;
        addButton.disabled = false;
      }, 1600);
    } catch (error) {
      addButton.textContent =
        error.message || 'TRY AGAIN';

      window.setTimeout(() => {
        addButton.innerHTML = originalButtonHtml;
        addButton.disabled = false;
      }, 2200);
    }
  });
});

    const switchMode = (mode) => {
        currentMode = mode;
      modeButtons.forEach((button) => {
        const isActive = button.dataset.antixModeButton === mode;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      views.forEach((view) => {
        const isActive = view.dataset.antixView === mode;

        view.classList.toggle('is-active', isActive);
        view.hidden = !isActive;
      });
    };

    modeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        switchMode(button.dataset.antixModeButton);
      });
    });

    if (roamView) {
      roamView.addEventListener('pointerdown', (event) => {
        if (
          event.button !== 0 ||
          event.target.closest(
            'button, input, select, textarea, [data-antix-mode-button]'
          )
        ) {
          return;
        }

        dragging = true;
        moved = false;
        startX = event.clientX;
        startY = event.clientY;
        savedX = currentX;
        savedY = currentY;
        const productCard = event.target.closest('[data-antix-product]');

activeProductHandle = productCard
  ? productCard.dataset.productHandle
  : '';

        roamView.classList.add('is-dragging');
        roamView.setPointerCapture(event.pointerId);
      });

      roamView.addEventListener('pointermove', (event) => {
        if (!dragging) return;

        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;

        if (Math.abs(deltaX) > 5 || Math.abs(deltaY) > 5) {
          moved = true;
        }

        currentX = savedX + deltaX;
        currentY = savedY + deltaY;

        updateRoamPosition();
      });

    const stopDragging = (event) => {
  if (!dragging) return;

  const shouldOpenProduct = !moved && activeProductHandle;
  const productHandle = activeProductHandle;

  dragging = false;
  roamView.classList.remove('is-dragging');

  if (roamView.hasPointerCapture(event.pointerId)) {
    roamView.releasePointerCapture(event.pointerId);
  }

  if (moved && roamCards.length > 0) {
  const roamRect = roamView.getBoundingClientRect();
  const centerX = roamRect.left + roamRect.width / 2;
  const centerY = roamRect.top + roamRect.height / 2;

  let nearestCard = null;
  let nearestDistance = Infinity;

  roamCards.forEach((card) => {
    const cardRect = card.getBoundingClientRect();
    const cardCenterX = cardRect.left + cardRect.width / 2;
    const cardCenterY = cardRect.top + cardRect.height / 2;

    const distance = Math.hypot(
      cardCenterX - centerX,
      cardCenterY - centerY
    );

    if (distance < nearestDistance) {
      nearestDistance = distance;
      nearestCard = card;
    }
  });

  if (nearestCard) {
    setRoamFocus(nearestCard);

currentX = 0;
currentY = 0;
  }
}

savedX = currentX;
savedY = currentY;

updateRoamPosition();

  activeProductHandle = '';

  if (shouldOpenProduct) {
    event.preventDefault();
    openProduct(productHandle);
  }
};

      roamView.addEventListener('pointerup', stopDragging);
      roamView.addEventListener('pointercancel', stopDragging);

      roamView.addEventListener(
  'click',
  (event) => {
    const productLink = event.target.closest(
      '.antix-experience__product-link'
    );

    if (!productLink) return;

    event.preventDefault();
    event.stopPropagation();
    moved = false;
  },
  true
);
    }

    gridProductLinks.forEach((link) => {
  link.addEventListener('click', (event) => {
    event.preventDefault();

    const productCard = link.closest(
      '.antix-experience__grid-card'
    );

    const productHandle = productCard
      ? productCard.dataset.productHandle
      : '';

    openProduct(productHandle);
  });
});

if (productClose) {
  productClose.addEventListener('click', closeProduct);
}

if (menuButton) {
  menuButton.addEventListener('click', openMenu);
}

if (themeButton) {
  themeButton.addEventListener('click', () => {
    currentTheme = currentTheme === 'dark' ? 'light' : 'dark';

    applyTheme(currentTheme);

    try {
      localStorage.setItem('antix-theme', currentTheme);
    } catch (error) {
      // Continue without saved preference.
    }
  });
}

if (menuClose) {
  menuClose.addEventListener('click', closeMenu);
}

if (artboardClose) {
  artboardClose.addEventListener('click', closeArtboard);
}

if (informationClose) {
  informationClose.addEventListener('click', closeInformation);
}

if (cartButton) {
  cartButton.addEventListener('click', async (event) => {
    event.preventDefault();

    try {
      await openCart();
    } catch (error) {
      console.error(error);
    }
  });
}

cartCloseButtons.forEach((button) => {
  button.addEventListener('click', closeCart);
});

if (cartItems) {
  cartItems.addEventListener('click', async (event) => {
    const changeButton = event.target.closest(
      '[data-antix-cart-change]'
    );

    if (!changeButton || changeButton.disabled) return;

    const line = Number(changeButton.dataset.line);
    const quantity = Number(changeButton.dataset.quantity);

    if (!line || Number.isNaN(quantity)) return;

    changeButton.disabled = true;

    try {
      await changeCartLine(line, quantity);
    } catch (error) {
      console.error(error);
      changeButton.disabled = false;
    }
  });
}

menuLinks.forEach((link) => {
  link.addEventListener('click', () => {
    const destination = link.dataset.antixMenuLink;

    if (destination === 'home') {
      closeMenu();
      closeArtboard();

      closeProduct();
      switchMode('roam');
      return;
    }

    if (destination === 'artboard') {
      openArtboard();
    }
    if (destination === 'information') {
  openInformation();
}
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  if (cartLayer && !cartLayer.hidden) {
    closeCart();
    return;
  }

  if (information && !information.hidden) {
  closeInformation();
  return;
}

  if (artboard && !artboard.hidden) {
    closeArtboard();
    return;
  }

  if (menu && !menu.hidden) {
    closeMenu();
    return;
  }

  if (productView && !productView.hidden) {
    closeProduct();
  }
});
    switchMode('roam');
  };

  const initializeAll = () => {
    document
      .querySelectorAll('[data-antix-experience]')
      .forEach(initializeAntixExperience);
  };

  document.addEventListener('DOMContentLoaded', initializeAll);
  document.addEventListener('shopify:section:load', initializeAll);

  document.addEventListener('shopify:section:unload', () => {
    if (!document.querySelector('[data-antix-experience]')) {
      document.body.classList.remove('antix-full-experience-active');
    }
  });

  initializeAll();
})();